<script>
import DeviceInfo from "@/views/users/components/DeviceInfo.vue";
import { mapState } from "pinia";
import { useAppStore } from "@/store/app.store";
import { MOBILE_USER_TRACKING_STATUS_MAP } from "@/data/tracking.ts";
import { useDateTime } from "@/composables/index.ts";

const { timeAgo } = useDateTime();

export default {
  name: "MobileStatus",
  components: { DeviceInfo },
  inheritAttrs: false,
  props: {
    user: Object,
  },
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
    trackingStatus() {
      return MOBILE_USER_TRACKING_STATUS_MAP[this.user.mobileUserTrackingStatus];
    },
    lastTrackingTime() {
      return this.user.mobileUserTrackingStatusDt ? timeAgo(this.user.mobileUserTrackingStatusDt) : "—";
    },
    lastOnline() {
      return this.user.mobileUserLastOnline ? timeAgo(this.user.mobileUserLastOnline) : "—";
    },
  },
};
</script>

<template>
  <v-tooltip v-if="user.mobileUserHasPassword" :disabled="!user.mobileUserLastOnline" location="top start">
    <template #activator="{ props }">
      <v-icon
        :class="$attrs.class"
        :color="user.mobileUserLastOnline ? 'success' : 'grey'"
        icon="mdi-cellphone"
        v-bind="props"
      ></v-icon>
    </template>
    <div>
      Device:
      <device-info :devices="user.mobileUserDevices"></device-info>
    </div>
    <div>Last online: {{ lastOnline }}</div>
    <div>GPS tracking: {{ trackingStatus }}, {{ lastTrackingTime }}</div>
  </v-tooltip>
</template>

<style lang="scss" scoped></style>
